"use client";

import { usePathname } from "next/navigation";
import { useStyles } from "./styles";
import { useAppSelector } from "@/redux/store";

interface CollapsedViewProps {
  prompt: string;
  images: File[];
  onPromptChange: (prompt: string) => void;
  onImagesChange: (images: File[]) => void;
  onExpand: () => void;
  onSubmit: () => void;
  isSubscribed: boolean;
  isGenerating?: boolean;
}

const CollapsedView: React.FC<CollapsedViewProps> = ({
  prompt,
  images,
  onPromptChange,
  onImagesChange,
  onExpand,
  onSubmit,
  isSubscribed,
  isGenerating = false,
}) => {
  const pathname = usePathname();
  const isHomePage = pathname === "/" || pathname === "";
  const { classes } = useStyles({ isHomePage, isGenerating });
  const showSignupModal = useAppSelector((state) => state.user.showSignupModal);

  const handleClick = (e: React.MouseEvent) => {
    if (window.getSelection()?.toString() || isGenerating || showSignupModal)
      return;
    onExpand();
  };

  const handleInputClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isGenerating && !showSignupModal) {
      onExpand();
    }
  };

  return (
    <div className={classes.container} onClick={handleClick}>
      <div className={classes.content}>
        {images.length > 0 && (
          <div className={classes.imagePreviewsWrapper}>
            {images.slice(0, 3).map((image, index) => (
              <div
                key={`collapsed-preview-${index}`}
                className={classes.imagePreview}
              >
                <img
                  src={URL.createObjectURL(image)}
                  alt={`Upload ${index + 1}`}
                  className={classes.previewImage}
                />
              </div>
            ))}
            {images.length > 3 && (
              <div className={classes.moreImages}>+{images.length - 3}</div>
            )}
          </div>
        )}
        <input
          type="text"
          placeholder={
            isGenerating ? "Generating..." : "What do you want to make?"
          }
          value={prompt}
          onChange={(e) => onPromptChange(e.target.value)}
          onClick={handleInputClick}
          className={classes.input}
          readOnly
          disabled={isGenerating}
        />
      </div>
    </div>
  );
};

export default CollapsedView;
